import * as React from "react";
import {VeboxDrawer, VeboxDrawerProps} from "../../../users/components/VeboxDrawer";
import {ReadAndWriteContext} from "../../../providers/ReadAndWriteProvider";
import {Display} from "../../../components/Display";
import "./styles.scss";
import {Loader} from "../../../components/Utils/loader/Loader";


export const ReadAndWriteDrawer: React.FC<React.HTMLProps<HTMLDivElement> & VeboxDrawerProps> = (props) => {
    const {AppTranslations, deviceSlaveDetails} = React.useContext(ReadAndWriteContext)
    const {isLoading, data, error} = deviceSlaveDetails;
    const model = data?.model;


    return (
        <VeboxDrawer
            className={"side-menu details-menu"}
            header={<h1 className={"ellipsis"}>{data?.model?.name}</h1>}
            defaultOpen={props?.defaultOpen}
            closable={props?.closable}
            {...props}
        >
            <Display isVisible={isLoading}>
                <div>
                    <Loader relativelyCentered={true}/>
                </div>
            </Display>
            <Display isVisible={!isLoading && !error}>
                <div className={"user-info-drawer"}>
                    <div className={"flx-row flx-align-center padding-left-25"}>
                        <img
                            src={`${model?.logo}`}
                            alt={"Device logo"}
                            width={72}
                            height={72}
                        />
                        <div className={"flx-col"}>
                            <LabelValue
                                valueClassName={"font-weight-400"}
                                labelClassName={"font-weight-300 "}
                                rootClassName={"padding-bottom-0 padding-left-10"}
                                label={AppTranslations.readAndWrite.deviceSlaveModelIdentifier}
                                value={data?.deviceSlaveModelIdentifier ?? '-'}
                            />
                            <LabelValue
                                valueClassName={"font-weight-400"}
                                labelClassName={"font-weight-300"}
                                rootClassName={"padding-bottom-0 padding-left-10"}
                                label={AppTranslations.readAndWrite.deviceSalveType}
                                value={model?.typeName ?? '-'}
                            />
                        </div>
                    </div>
                    <LabelValue
                        rootClassName={"grid-template-rows-1fr first-functionality-label"}
                        valueClassName={"font-weight-400"}
                        label={""}
                        value={data?.doorOpeningSupported ? AppTranslations.readAndWrite.doorOpeningSupported : AppTranslations.readAndWrite.doorOpeningNotSupported}
                        showStatus={true}
                        statusClassName={data?.doorOpeningSupported ? "available" : "disabled"}
                        hideLabel={true}
                    />
                    <LabelValue
                        rootClassName={"grid-template-rows-1fr functionality-label"}
                        valueClassName={"font-weight-400"}
                        label={""}
                        value={data?.doorOpeningSupported ? AppTranslations.readAndWrite.lockUnlockSupported : AppTranslations.readAndWrite.lockUnlockNotSupported}
                        showStatus={true}
                        statusClassName={data?.lockSupported ? "available" : "disabled"}
                        hideLabel={true}
                    />
                </div>
            </Display>
        </VeboxDrawer>
    );
};


type LabelValueProps = {
    label: string,
    value: string,
    valueClassName?: string,
    labelClassName?: string
    rootClassName?: string
    showStatus?: boolean
    statusClassName?: string
    hideLabel?: boolean
}

const LabelValue: React.FC<LabelValueProps> = (props) => {
    return (
        <p className={"label-value " + (props?.rootClassName ?? "")}>
            <Display isVisible={!props?.hideLabel}>
                <span className={"padding-bottom-3 " + props?.labelClassName ?? ""}>{props.label}</span>
            </Display>
            <span className={"padding-bottom-3 ellipsis " + (props?.valueClassName ?? "")}>
                <Display isVisible={props?.showStatus}>
                    <div className={"status-circle " + (props?.statusClassName ?? "")}></div>
                </Display>
                {props.value}
            </span>
        </p>
    );
}